import { useContext, useEffect } from "react";
import { ProgressBar, Table } from "react-bootstrap";
import { DateInput } from "react-hichestan-datetimepicker";
import { isEmpty } from "lodash";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import PaginationList from "../../../utils/PaginationList/PaginationList";
import TooltipTitle from "../../../utils/TooltipTitle/TooltipTitle";
import Animations from "../../../utils/Animations";
import ExportCSV from "../../../utils/ExportCSV/ExportCSV";
import { CreateOrder } from "../OrderAdmin/EditOrderParams/EditOrderParams";
import { orderAdminContext } from "../../../context/Admin/OrderAdminContext/OrderAdminContext";
import {
  dialogContainerStyle,
  convertDate,
  separateScheduleTime,
  writeToClipboard,
  convertDataToCSV,
  orderProgressToColor,
  orderProgressToText,
} from "../../../utils";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";

const OrdersAdmin = ({ isOfficial, isWaiting, isUserCancel, isUserReturn }) => {
  const permission = useSelector((state) => state.permission);
  const socket = useSelector((state) => state.socket);

  const { pathname } = useLocation();

  const {
    orders,
    setPersonnels,
    categories,
    config,
    status,
    setStatus,
    employers,
    services,
    search,
    setSearch,
    sort_by,
    setSort_by,
    category,
    setCategory,
    employer,
    setEmployer,
    service,
    setService,
    totalCount,
    pageNumber,
    setPageNumber,
    limit,
    setLimit,
    to_date,
    setTo_date,
    from_date,
    setFrom_date,
    lastDay,
    setLastDay,
    isSpecial,
    isShowPersonnelModal,
    isShowAdvancedSearch,
    setIsShowAdvancedSearch,
    isShowFilter,
    setIsShowFilter,
    personnelSearch,
    personnelType,
    handleGetOrders,
    handleGetCategoryItemList,
    handleGetEmployers,
    handleGetServices,
    handleGetPersonnels,
    handleGetSurveyItemList,
    checkViewOrders,
    handleDeleteOrder,
  } = useContext(orderAdminContext);

  useEffect(() => {
    handleGetOrders();
  }, [
    pageNumber,
    limit,
    status,
    category,
    employer,
    service,
    sort_by,
    lastDay,
    isOfficial,
    isWaiting,
    isUserCancel,
    isUserReturn,
  ]);

  useEffect(() => {
    setPageNumber(1);
  }, [
    status,
    category,
    employer,
    service,
    sort_by,
    isShowAdvancedSearch,
    isShowFilter,
    isOfficial,
    isWaiting,
    isUserCancel,
    isUserReturn,
  ]);

  useEffect(() => {
    if (isShowFilter) setSort_by("-schedule_time");
    else setSort_by("-created");
  }, [isShowFilter, isOfficial, isWaiting, isUserCancel, isUserReturn]);

  useEffect(() => {
    handleGetCategoryItemList();
    handleGetEmployers();
    handleGetServices();
    handleGetSurveyItemList();
  }, [isOfficial, isWaiting, isUserCancel, isUserReturn]);

  useEffect(() => {
    if (isShowPersonnelModal && personnelSearch) handleGetPersonnels();
    else setPersonnels([]);
  }, [
    personnelSearch,
    personnelType,
    isSpecial,
    isOfficial,
    isWaiting,
    isUserCancel,
    isUserReturn,
  ]);

  useEffect(() => {
    const updateOrder = () => handleGetOrders();

    if (!isEmpty(socket)) {
      socket.on("update-orders", updateOrder);

      return () => {
        socket.off("update-orders", updateOrder);
      };
    }
  }, [socket]);

  const onNavigate = (pk) => {
    const path = isWaiting
      ? `${pathname?.replace("Waiting-Payment-Orders", "Orders")}/${pk}`
      : isUserReturn
      ? `${pathname?.replace("UserReturnOrders", "Orders")}/${pk}`
      : isUserCancel
      ? `${pathname?.replace("UserCancelOrders", "Orders")}/${pk}`
      : isOfficial
      ? `${pathname?.replace("Official-Invoice", "Orders")}/${pk}`
      : `${pathname}/${pk}`;
    window.open(path, "_blank");
  };

  const datePaginationLabel = (page) => {
    const date = new Date();
    date.setDate(date.getDate() - (page - 3));

    let result = "";
    switch (page) {
      case 1:
        result = "سفارشات آینده";
        break;
      case 2:
        result = "فردا";
        break;
      case 3:
        result = "امروز";
        break;
      case 4:
        result = "دیروز";
        break;

      default:
        result = convertDate(date, "dddd DD MMM");
        break;
    }

    return result;
  };

  const sortByOptions = [
    {
      label: "تاریخ ایجاد",
      options: [
        { title: "نزولی", value: "-created" },
        { title: "صعودی", value: "created" },
      ],
    },
    {
      label: "تاریخ انجام",
      options: [
        { title: "نزولی", value: "-schedule_time" },
        { title: "صعودی", value: "schedule_time" },
      ],
    },
    {
      label: "شماره همراه مشتری",
      options: [
        { title: "نزولی", value: "-client__mobile" },
        { title: "صعودی", value: "client__mobile" },
      ],
    },
    {
      label: "کد پیگیری",
      options: [
        { title: "نزولی", value: "-id" },
        { title: "صعودی", value: "id" },
      ],
    },
    {
      label: "شماره همراه پرسنل",
      options: [
        { title: "نزولی", value: "-personnel__mobile" },
        { title: "صعودی", value: "personnel__mobile" },
      ],
    },
    {
      label: "وضعیت",
      options: [
        { title: "نزولی", value: "-status" },
        { title: "صعودی", value: "status" },
      ],
    },
    {
      label: "نوع سفارش",
      options: [
        { title: "نزولی", value: "-unique_id" },
        { title: "صعودی", value: "unique_id" },
      ],
    },
  ];

  const totalToConsiderNewUser = 1;
  const totalToConsiderRecurrent = 10;
  const thisToConsiderNew = 2;
  const convertClientType = (_total, _this, _successful) => {
    if (_total <= totalToConsiderNewUser)
      return <span className="mr-1 badge badge-info">جدید</span>;
    if (_this <= thisToConsiderNew)
      return <span className="mr-1 badge badge-warning">اولین</span>;
    if (_successful >= totalToConsiderRecurrent)
      return <span className="mr-1 badge badge-primary">ثابت</span>;
  };

  const requestSort = (key) => {
    let direction = "";
    if (sort_by.includes(key) && !sort_by.includes("-")) direction = "-";

    setSort_by(`${direction}${key}`);
  };

  const sortIcon = (key) => {
    const isCurrent = [`-${key}`, key].includes(sort_by);
    const direction = isCurrent ? (sort_by.includes("-") ? "desc" : "asc") : "";
    return (
      <span onClick={() => requestSort(key)} className="cursor-pointer">
        <i
          className={`fas fa-sort-amount-${
            direction === "asc"
              ? "up text-primary"
              : direction === "desc"
              ? "down text-primary"
              : "up"
          }`}
        />
      </span>
    );
  };

  const siteTitle = isWaiting
    ? "سفارشات منتظر پرداخت"
    : isUserReturn
    ? "آخرین مشتریان بازگشتی"
    : isUserCancel
    ? "آخرین سفارشات لغوشده"
    : isOfficial
    ? "درخواست های فاکتور رسمی"
    : "سفارشات";

  return (
    <>
      <SiteTitle title={siteTitle} />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: siteTitle, type: "a" },
        ]}
        title={`لیست ${siteTitle}`}
      />

      <CardLayout>
        <div className="mb-2">
          {!isUserReturn && !isUserCancel && !isWaiting && !isOfficial && (
            <CreateOrder />
          )}
          <button
            onClick={() => setIsShowAdvancedSearch(!isShowAdvancedSearch)}
            className={`btn btn-${
              isShowAdvancedSearch ? "" : "outline-"
            }primary mr-2`}
          >
            جستجو پیشرفته
          </button>
          <button
            onClick={() => setIsShowFilter(!isShowFilter)}
            className={`btn btn-${isShowFilter ? "" : "outline-"}info mr-2`}
          >
            فیلتر روزانه
          </button>

          <ExportCSV
            csvData={() => convertDataToCSV(orders, "orders", config)}
          />
        </div>
        <form className="input-group mb-3" onSubmit={handleGetOrders}>
          <input
            type="text"
            name="search"
            autoComplete="off"
            placeholder="جستجو ..."
            className="form-control"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="input-group-append">
            <button type="submit" className="btn btn-primary">
              جستجو
            </button>
          </div>
        </form>
        {isShowAdvancedSearch && (
          <Animations name="fadeIn">
            <div className="row">
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <TooltipTitle title="از تاریخ">
                  <DateInput
                    id="from_date"
                    value={from_date}
                    className="form-control"
                    name="from_date"
                    onChange={(e) => setFrom_date(e.target.value)}
                    autoOk="false"
                    placeholder="از تاریخ"
                    dialogContainerStyle={dialogContainerStyle}
                  />
                </TooltipTitle>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <TooltipTitle title="تا تاریخ">
                  <DateInput
                    id="to_date"
                    value={to_date}
                    className="form-control"
                    name="to_date"
                    onChange={(e) => setTo_date(e.target.value)}
                    autoOk="false"
                    placeholder="تا تاریخ"
                    dialogContainerStyle={dialogContainerStyle}
                  />
                </TooltipTitle>
              </div>
              {!isUserReturn && !isUserCancel && !isWaiting && (
                <div className="col-12 col-md-6 col-lg-3 mb-2">
                  <TooltipTitle title="وضعیت">
                    <select
                      className="form-control"
                      name="status"
                      onChange={(e) =>
                        setStatus(
                          e.target.value ? Number(e.target.value) : null
                        )
                      }
                    >
                      <option selected value="">
                        وضعیت: همه
                      </option>
                      {config?.STATUS_CHOICES?.map((_value, index) => (
                        <option
                          key={index}
                          selected={index === status}
                          value={index}
                        >
                          {_value}
                        </option>
                      ))}
                    </select>
                  </TooltipTitle>
                </div>
              )}
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <TooltipTitle title="دسته بندی">
                  <select
                    className="form-control"
                    name="category"
                    onChange={(e) =>
                      setCategory(e.target.value ? e.target.value : null)
                    }
                  >
                    <option selected value="">
                      دسته بندی: همه
                    </option>
                    {categories?.map((_value, index) => (
                      <option
                        key={index}
                        selected={_value === category}
                        value={_value}
                      >
                        {_value}
                      </option>
                    ))}
                  </select>
                </TooltipTitle>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <TooltipTitle title="سازمان">
                  <select
                    className="form-control"
                    name="employer"
                    onChange={(e) =>
                      setEmployer(e.target.value ? e.target.value : null)
                    }
                  >
                    <option selected value="">
                      سازمان: همه
                    </option>
                    <option key="null" value="null">
                      فقط عادی
                    </option>
                    {employers?.map((_value, index) => (
                      <option
                        key={index}
                        selected={_value?.id === employer}
                        value={_value?.id}
                      >
                        {_value?.name}
                      </option>
                    ))}
                  </select>
                </TooltipTitle>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <TooltipTitle title="سفارش">
                  <select
                    className="form-control"
                    name="service"
                    onChange={(e) =>
                      setService(e.target.value ? e.target.value : null)
                    }
                  >
                    <option selected value="">
                      سفارش: همه
                    </option>
                    {services?.map((_value, index) => (
                      <option
                        key={index}
                        selected={_value?.name === service}
                        value={_value?.name}
                      >
                        {_value?.name}
                      </option>
                    ))}
                  </select>
                </TooltipTitle>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <TooltipTitle title="مرتب سازی بر اساس">
                  <select
                    className="form-control"
                    value={sort_by}
                    onChange={(e) => setSort_by(e.target.value)}
                  >
                    {sortByOptions.map((_item, index) => (
                      <optgroup label={_item.label} key={index}>
                        {_item.options?.map((option) => (
                          <option
                            key={option.value}
                            selected={sort_by === option.value}
                            value={option.value}
                          >
                            {option.title}
                          </option>
                        ))}
                      </optgroup>
                    ))}
                  </select>
                </TooltipTitle>
              </div>
            </div>
          </Animations>
        )}
        {isShowFilter && (
          <PaginationList
            initialPage={lastDay - 1}
            setPageNumber={setLastDay}
            pageCount={lastDay + 5}
            label={datePaginationLabel}
          />
        )}
        <hr className="my-2" />
        <div className="d-flex justify-content-between align-items-center mt-2">
          <PaginationList
            setPageNumber={setPageNumber}
            pageCount={totalCount / limit}
          />
          <div className="mb-2">
            تعداد کل :{" "}
            <span className="badge badge-primary font-weight-bold">
              {totalCount}
            </span>
          </div>
          <div>
            <select
              className="form-control mb-2"
              onChange={(e) => setLimit(Number(e.target.value))}
            >
              <option value={10} selected={10 === limit}>
                10
              </option>
              <option value={25} selected={25 === limit}>
                25
              </option>
              <option value={50} selected={50 === limit}>
                50
              </option>
              <option value={75} selected={75 === limit}>
                75
              </option>
              <option value={100} selected={100 === limit}>
                100
              </option>
              <option value={200} selected={200 === limit}>
                200
              </option>
              <option value={400} selected={400 === limit}>
                400
              </option>
              <option value={700} selected={700 === limit}>
                700
              </option>
              <option value={1000} selected={1000 === limit}>
                1000
              </option>
            </select>
          </div>
        </div>
        {isEmpty(orders) ? (
          <EmptyData />
        ) : (
          <Table
            responsive
            hover
            borderless
            striped
            className="scrollable-table"
          >
            <thead className="thead-dark text-center">
              <tr>
                <th>#</th>
                <th>نوع سفارش {sortIcon("unique_id")}</th>
                <th>تاریخ {sortIcon("schedule_time")}</th>
                <th>زمان</th>
                <th>کدپیگیری {sortIcon("id")}</th>
                <th>نام و نام خانوادگی مشتری</th>
                <th>شماره موبایل مشتری {sortIcon("client__mobile")}</th>
                {isUserCancel && <th>دلیل لغو</th>}
                <th>پیشرفت</th>
                <th>سازمان مشتری</th>
                <th>نام پرسنل {sortIcon("personnel__mobile")}</th>
                <th>نوع سفارش</th>
                <th>T/S/C</th>
                <th>وضعیت {sortIcon("status")}</th>
                <th />
                {permission.admin_delete && <th />}
              </tr>
            </thead>
            <tbody className="text-center">
              {orders.map((_item, index) => (
                <tr
                  key={_item?.pk}
                  className={`${checkViewOrders(_item.pk) ? "" : "table-info"}`}
                >
                  <td
                    onClick={() => onNavigate(_item?.pk)}
                    className="cursorPointer"
                  >
                    <span
                      className={`badge badge-${
                        _item.have_violation
                          ? "danger"
                          : _item.have_failure_request
                          ? "warning"
                          : "light"
                      }`}
                    >
                      {index + 1}
                    </span>
                  </td>
                  <td
                    onClick={() => onNavigate(_item?.pk)}
                    className="cursorPointer"
                  >
                    {_item.service}
                  </td>
                  <td
                    onClick={() => onNavigate(_item?.pk)}
                    className="cursorPointer"
                  >
                    {separateScheduleTime(_item.schedule_time, true)?.date}
                  </td>
                  <td
                    onClick={() => onNavigate(_item?.pk)}
                    className="cursorPointer"
                  >
                    {separateScheduleTime(_item.schedule_time, true)?.time}
                  </td>
                  <td
                    onClick={() => writeToClipboard(_item?.ref_num)}
                    className="cursorPointer"
                  >
                    <span>{_item?.ref_num}</span>
                  </td>
                  <td
                    onClick={() =>
                      writeToClipboard(
                        `${_item?.client?.first_name} ${_item?.client?.last_name}`
                      )
                    }
                    className="cursorPointer"
                  >
                    <div style={{ position: "relative" }}>
                      <span>
                        {convertClientType(
                          _item?.total,
                          _item?.this,
                          _item?.successful
                        )}
                        {_item?.client?.first_name} {_item?.client?.last_name}{" "}
                      </span>
                    </div>
                  </td>
                  <td
                    onClick={() => writeToClipboard(_item?.client?.mobile)}
                    className="cursorPointer"
                  >
                    {_item?.client?.mobile}
                  </td>
                  {isUserCancel && (
                    <td
                      onClick={() => onNavigate(_item?.pk)}
                      className="cursorPointer"
                    >
                      {_item?.cancelingreason?.description || "-"}
                    </td>
                  )}
                  <td
                    onClick={() => onNavigate(_item?.pk)}
                    className="cursorPointer"
                  >
                    <ProgressBar
                      label={orderProgressToText(_item.progress)}
                      striped
                      animated
                      variant={orderProgressToColor(_item.progress)}
                      now={_item.progress}
                      className="h-25"
                    />
                  </td>
                  <td onClick={() => onNavigate(_item?.pk)}>
                    {_item?.client?.employer ? (
                      <span className="badge badge-primary font-weight-bold">
                        {_item?.client?.employer?.name}
                      </span>
                    ) : (
                      <span className="badge badge-secondary font-weight-bold">
                        کاربر عادی
                      </span>
                    )}
                  </td>
                  <td
                  // onClick={() => onNavigate(_item?.pk)}
                  // className="cursorPointer"
                  >
                    {!isEmpty(_item?.personnel) &&
                      _item?.personnel?.map((_personnelVal, index) => (
                        <span
                          className={`cursor-pointer d-block ${
                            index + 1 !== _item?.personnel.length
                              ? "border-bottom"
                              : ""
                          }`}
                          onClick={() =>
                            writeToClipboard(
                              `${_personnelVal?.first_name} ${_personnelVal?.last_name}`
                            )
                          }
                          onDoubleClick={() =>
                            writeToClipboard(_personnelVal?.mobile)
                          }
                        >
                          <TooltipTitle
                            title={_personnelVal?.mobile ?? "ندارد"}
                            placement="bottom"
                          >
                            <span
                              type="button"
                              className="mx-1"
                              // onClick={() =>
                              //   permission.personnel_get && handleGetPersonnel(_personnelVal.id)
                              // }
                            >
                              {_personnelVal?.first_name}{" "}
                              {_personnelVal?.last_name}
                            </span>
                          </TooltipTitle>
                        </span>
                      ))}
                  </td>
                  <td
                    onClick={() => onNavigate(_item?.pk)}
                    className="cursorPointer"
                  >
                    {_item?.need_special_personnel ? (
                      <span className="badge badge-primary font-weight-bold">
                        ویژه
                      </span>
                    ) : (
                      <span className="badge badge-secondary font-weight-bold">
                        عادی
                      </span>
                    )}
                  </td>
                  <td
                    onClick={() => onNavigate(_item?.pk)}
                    className="cursorPointer"
                  >
                    <TooltipTitle
                      placement="bottom"
                      title="کل سفارشات از این نوع/سفارشات موفق مشتری/کل سفارشات مشتری"
                    >
                      <span>
                        {_item?.total}/{_item?.successful}/{_item?.this}
                      </span>
                    </TooltipTitle>
                  </td>
                  <td
                    onClick={() => onNavigate(_item?.pk)}
                    className="cursorPointer"
                  >
                    {config?.STATUS_CHOICES &&
                      _item?.status >= 0 &&
                      config?.STATUS_CHOICES[_item?.status]}
                  </td>
                  <td
                    onClick={() => onNavigate(_item?.pk)}
                    className="cursorPointer"
                  >
                    <span
                      className={`badge badge-${
                        _item.rating > 0
                          ? "success"
                          : _item.rating <= 0 && _item?.status >= 11
                          ? "danger"
                          : "light"
                      } d-flex justify-content-between align-items-center gap-2`}
                    >
                      <i className="fa fa-star text-warning" />
                      <span>{_item.rating || "0"}</span>
                    </span>
                  </td>
                  {permission.admin_delete && (
                    <td>
                      <i
                        onClick={() =>
                          areYouSureMessage(
                            () => handleDeleteOrder(_item),
                            `آیا از حذف سفارش ${_item?.client?.first_name} ${_item?.client?.last_name} اطمینان دارید؟`
                          )
                        }
                        className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                      />
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </CardLayout>
    </>
  );
};

export default OrdersAdmin;
